import "./SelectField.css";
import { useId } from "react";

export default function SelectField(props) {
  const id = useId();
  const invalid = Boolean(props.error);

  return (
    <div className={`field col${props.disabled ? " field-locked" : ""}`}>
      <div className="field-top row">
        <label className="field-label t-label" htmlFor={id}>
          {props.label}
          {props.required ? (
            <span className="field-required-tag t-eyebrow">Required</span>
          ) : (
            <span className="field-required-tag t-eyebrow">Optional</span>
          )}
        </label>
        {props.hint ? <span className="field-hint t-mono">{props.hint}</span> : null}
      </div>

      <div className={`field-box select-box row${invalid ? " field-box-invalid" : ""}`}>
        <select
          id={id}
          className="field-input select-input"
          value={props.value || ""}
          onChange={(e) => props.onChange(e.target.value)}
          disabled={props.disabled}
          aria-invalid={invalid}
          aria-describedby={props.error || props.help ? `${id}-msg` : undefined}
        >
          <option value="">{props.placeholder || "Select one"}</option>
          {(props.options || []).map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
        <span className="select-caret" aria-hidden="true">▾</span>
      </div>

      {props.error || props.help ? (
        <p
          id={`${id}-msg`}
          className={`field-msg t-body-sm${invalid ? " field-msg-error" : ""}`}
          role={invalid ? "alert" : undefined}
        >
          {props.error || props.help}
        </p>
      ) : null}
    </div>
  );
}
